import { time } from "echarts";

export default {
  pm: {
    home: {
      project: {
        add: "添加项目",
        project_list: "项目列表",
        search: "输入项目搜索",
        project_id: "项目编号",
        project_name: "项目名称",
        project_state: "项目状态",
        delivery_state: "交付状态",
        pro_start_time: "创建时间",
        pro_end_time: "截止时间",
        pro_update_time: "更新时间",
        period: "项目周期",
        period2: "项目始末",
        type: "项目类型",
        library: "文库大小",
        dec: "项目描述",
        contract: "合同号",
        sp_type: "物种来源",
        seq_plat: "测序平台",
        sep: "分选方式",
        sep_mark: "分选mark",
        sample_num: "样品数量",
        xiangqing: "详情",
        perioded: "项目时间(d)",
        perioded2: "实际工时(h)"
      },
      client: {
        id: "客户账号",
        name: "用户名",
        password: "客户密码",
        institution: "客户单位",
        expiration_time: "到期时间",
        email: "客户邮箱"
      },
      engineer: {
        name: "工程师名"
      },
      pm: {
        name: "项目经理"
      },
      da: {
        name: "数据管理员"
      }
    }
  },
  sample: {
    add: "添加样品",
    sample_list: "样品清单",
    search: "输入样品号搜索",
    start: "启动项目",
    sample_add: "添加样品",
    import: "批量导入",
    export: "批量导出",
    name: "样品名称",
    associate: "关联样本",
    species: "物种来源",
    tissue: "组织类型",
    condition: "样品条件",
    experimental_note: "实验备注",
    raw_data_path: "原始数据路径",
    analyze_data_path: "CR路径",
    eng_data_path: "CR路径",
    library_type: "文库类型",
    finsh_status: "完成情况",
    is_ae: "实验分析与否",
    phase0: "Phase0完成情况",
    phase1: "Phase1完成情况",
    create_by: "创建人",
    create_time: "创建时间",
    update_by: "更新人",
    update_time: "更新时间",
    note: "样品备注",
    cell_num: "捕获细胞数",
    experiment_scheme: "实验方案",
    leader: "项目负责人",
    lib_leader: "文库负责人",
    type: "样品类型",
    phase0_staus: "未完成phase0",
    phase1_staus: "未完成phase1",
    shiyan_staus: "样品上机",
    produce: "产品类型",
    send_time: "送样日期"
  },
  da: {
    search: "项目检索"
  },
  eng: {
    OSSpath: "OSS地址"
  },
  root: {
    detail: "项目情况",
    login: "账号管理",
    watch: "项目查看"
  },
  ex: {
    text: "预处理",
    wenku: "文库构建",
    zong: "预实验总表",
    tong: "统计表",
    add: "添加预处理",
    yangben: "样本处理和分选",
    fenxuan: "分选",
    shangji: "上机",
    type: "样本处理类型",
    media: "保存介质",
    method: "处理方式",
    crack_time: "裂解时间",
    concent: "裂解液浓度",
    liquid_volume: "裂解液体积(ul)",
    filters: "过滤",
    file: "样本图片",
    sort_date: "实验日期",
    sort_type: "分选方式",
    sort_marker: "分选marker",
    facs_pro: "FACS比例(%)",
    facs_nuc_num: "FACS细胞(核)数(万个)",
    cell_viabily: "细胞活率(%)",
    res_volume: "重悬体积(ul)",
    nuc_concent: "细胞(核)浓度(个/ul)",
    clu_rate: "结团率(%)",
    nuc_rate: "有核率(%)",
    nuc_num: "细胞(核)总数(万个)",
    cell_num: "细胞计数结果",
    version: "试剂版本",
    is_danger: "是否风险上机",
    com_num: "上机细胞数",
    chip_num: "芯片数量",
    lot_num: "试剂Lot号",
    remarks: "备注"
  },
  wenku: {
    gex: "GEX+ATAC'产品",
    5: "5'产品",
    3: "3'产品",
    atac: "ATAC'产品",
    wenku_3: "3'转录组文库",
    wenku_5: "5'转录组文库",
    cite_seq: "cite-seq文库",
    CellPlex: "CellPlex文库",
    hashtag: "hashtag文库",
    TCR: "TCR文库",
    BCR: "BCR文库",
    date: "建库日期",
    name: "文库名称",
    c_cycle_num: "cDNA扩增循环数",
    c_concent: "cDNA浓度 (ng/ul)",
    c_volume: "cDNA体积 (ul)",
    c_total: "cDNA总量 (ng)",
    cquality_date: "cDNA质检时间",
    cquality_res: "cDNA质检结果",
    cycle_num: "文库扩增循环数",
    concent: "文库浓度 (ng/ul)",
    volume: "文库体积 (ul)",
    capacity: "库容 (ng)",
    quality_date: "文库质检时间",
    quality_res: "文库质检结果",
    quality_finish: "文库完成",
    experiment_date: "样本处理实验日期"
  },
  exda: {
    title: "文库送测汇总表",
    send_test_time: "送测时间",
    logout_time: "下机时间",
    library_name: "文库名称",
    test_num: "测序数据量（G）"
  },
  desc: {
    name: "项目描述",
    add: "添加描述",
    people: "操作人",
    add_desc_title: "添加项目描述"
  },
  set: {
    reset: "重 置",
    config: "确 定",
    cancel: "取 消",
    edit: "编辑",
    delete: "删除",
    select: "请选择",
    input: "请输入",
    async: "同步",
    reseted: "已重置",
    search: "搜索",
    change: "更改",
    create: "创建",
    opt: "操作",
    save: "保存",
    myself: "显示本人"
  },
  user: {
    id: "身 份",
    pm: "项目经理",
    eng: "工程师",
    da: "数据管理员",
    ex: "实验员",
    exda: "实验数据管理员",
    count_num: "账 号",
    password: "密 码",
    new_paddword: "新 密 码",
    re_password: "确认密码"
  }
};



// WEBPACK FOOTER //
// ./src/lang/zh.js